const EVENT_TYPE = {
  LEAD: 'Lead',
  SIGNUP: 'CompleteRegistration',
} as const;

const sendEvent = (
  eventType: Values<typeof EVENT_TYPE>,
  params?: Record<string, unknown>,
) => {
  window.fbq('track', eventType, params);
};

export const fbLead = () => {
  sendEvent(EVENT_TYPE.LEAD);
};

export const fbCompleteRegistration = (
  city: string | null,
  zipCode: string | null,
  state: string | null,
  country: string | null,
  addressType?: string,
  category?: string,
  addressTypeId?: number,
  categoryId?: number,
) => {
  sendEvent(EVENT_TYPE.SIGNUP, {
    city,
    zip: zipCode,
    state,
    country,
    address_type: addressType,
    category,
    address_type_id: addressTypeId,
    category_id: categoryId,
  });
};
